export const loginActionData = [
  {
    name: 'signUpUser',
    label: 'Signup User',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signUpUserWithFirebase',
    label: 'Signup with Firebase',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signUpUserWithXano',
    label: 'Signup with Xano',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signUpUserWithBackendless',
    label: 'Signup with Backendless',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginUser',
    label: 'Login User',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'authErrorMessage',
        label: 'Authentication Error Message',
        type: 'text',
        value: 'Username or password does not match. Please try again',
        infoDescription: 'Display Error Message When User or Password is incorrect.',
      },
      {
        name: 'notFoundErrorMessage',
        label: 'User not found Error Message',
        type: 'text',
        value: 'This user does not exists.',
        infoDescription: 'Display Error Message When User does not exist.',
      },
      {
        name: 'othersErrorMessage',
        label: 'Others Error Message',
        type: 'text',
        value: 'Some Internal error. Please contact support.',
        infoDescription: 'Display Error Message when something goes wrong.',
      },
      {
        name: 'registerTwoFactorAuthPage',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithFirebase',
    label: 'Login With Firebase',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithXano',
    label: 'Login With Xano',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithBackendless',
    label: 'Login With Backendless',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithToken',
    label: 'Login User With Token',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Select Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'logoutUser',
    label: 'Logout User',
    args: [
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'sendResetPasswordEmail',
    label: 'Send Password Reset Email',
    args: [
      {
        name: 'page',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'refreshPageApi',
        options: [],
        value: '',
      },
      {
        name: 'pageComponent',
        label: 'Select Form Component',
        type: 'dropdown',
        optionsType: 'resetPassowordPageComponent',
        options: [],
        value: '',
      },
      {
        name: 'sendTo',
        label: 'Select Email Field',
        type: 'dropdown',
        optionsType: 'pageComponent',
        value: '',
      },
      {
        name: 'emailTemplate',
        label: 'Select Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
      {
        name: 'emailServicePlugin',
        label: 'Select Email Service Plugin',
        type: 'dropdown',
        optionsType: 'emailServicePluginApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'resetNewPassword',
    label: 'Reset new password',
    args: [
      {
        name: 'page',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'refreshPageApi',
        options: [],
        value: '',
      },
      {
        name: 'pageComponent',
        label: 'Select Form Component',
        type: 'dropdown',
        optionsType: 'resetPassowordPageComponent',
        options: [],
        value: '',
      },
      {
        name: 'password',
        label: 'Password',
        type: 'dropdown',
        optionsType: 'pageComponent',
        value: '',
      },
      {
        name: 'confirmPassword',
        label: 'Confirm Password',
        type: 'dropdown',
        optionsType: 'pageComponent',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signupAndLoginUser',
    label: 'Signup & Login User',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signupAndLoginAnonymousUser',
    label: 'Signup & Login Anonymous User',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'chnageOldPassword',
    label: 'Change Password',
    args: [],
  },
  {
    name: 'refreshCurrentLoggedInUser',
    label: 'Refresh Current Logged In User',
    args: [],
  },
  {
    name: 'refreshCurrentTenant',
    label: 'Refresh Current Tenant',
    args: [],
  },
  {
    name: 'refreshCurrentUserSettings',
    label: 'Refresh Current User Settings',
    args: [],
  },
  {
    name: 'saveUserWithCollectionReference',
    label: 'Create User along with Collection (Parent)',
    args: [
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'userRefField',
        label: 'User Reference Field',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'userRole',
        label: 'User Role',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'enableLoginUser',
        label: 'Login with recently created user',
        type: 'boolean',
        value: '',
      },
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginWithFacebook',
    label: 'Login with Facebook',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signUpWithFacebook',
    label: 'Sign Up with Facebook',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginWithTwitter',
    label: 'Login with Twitter',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signUpWithTwitter',
    label: 'Sign Up with Twitter',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
